var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { initializeNetworkBar } from './actions';
import { generateMainNavigation, getDefaultMainNavigation } from './helpers';
var handler = handleActions((_a = {},
    _a[initializeNetworkBar.toString()] = function (state, _a) {
        var mainNavNewContent = _a.payload.mainNavNewContent;
        return (__assign(__assign({}, state), { mainNavigation: generateMainNavigation(mainNavNewContent), isInitialized: true }));
    },
    _a), {
    isInitialized: false,
    mainNavigation: getDefaultMainNavigation(),
});
export default (_b = {},
    _b[reduxKey] = handler,
    _b);
//# sourceMappingURL=reducer.js.map